var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRareM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3072 4H12.7067V6.05774H11.3072V4ZM9.9076 6.05755H11.2864V8.11528H9.9076V6.05755ZM14.0924 8.11577H15.4711L15.4711 10.1666H16.8499V12.2243H15.4711L15.4711 10.1735H14.0924V8.11577ZM7.14317 10.1666H8.52193V12.2243H7.14317V10.1666ZM4.38568 19.8386V16.2289V15.6954H3V6.63994V5.26119H4.38568H5.76443V6.63301H7.14319V10.1665H5.76443V6.63994H4.38568V15.6815H19.6143V6.63994H18.2356V10.1665H16.8568V6.63301H18.2356V5.26119H19.6143H21V6.63994V15.6954H19.6282V19.8386H4.38568ZM5.77136 18.4598H18.2425V17.0742H5.77136V18.4598ZM9.90761 8.11577H8.52885V10.1735H9.90761V8.11577ZM14.0855 6.05755H12.7067V8.11528H14.0855V6.05755Z",
    fill: "#8A88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareM);
export default __webpack_public_path__ + "static/media/rare-m.b505581665038dbdebd7acdecafdcc6b.svg";
export { ForwardRef as ReactComponent };